"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

/**
 * Formats a US phone number using dashes, e.g. 4158675309 to 415-867-5309
 */
var PhoneFormatter = function PhoneFormatter(_ref) {
  var value = _ref.value;
  var areaCode = value.substring(0, 3);
  var regionalStart = value.substring(3, 6);
  var regionalEnd = value.substring(6);
  return "".concat(areaCode, "-").concat(regionalStart, "-").concat(regionalEnd);
};

PhoneFormatter.propTypes = {
  /** unformatted phone number, e.g. 4158675309 */
  value: _propTypes["default"].string.isRequired
};
var _default = PhoneFormatter;
exports["default"] = _default;